import './DeparturesReportCreate.scss';

import { useDeparturesReportForm } from "../../../hooks/useDeparturesReportCreateForm";
import { useGetFieldOptions } from "../../../hooks/useGetFieldOptions";

import { Field } from "../../../common-components/Field/Field";

const DeparturesReportCreate = () => {
    const { formId, adaptedFieldList } = useDeparturesReportForm();

    useGetFieldOptions()

    return (
        <div className={"departures-report-create"}>
            <div className={"departures-report-create_container"}>
                <div className={"departures-report-create_form"}>
                    {adaptedFieldList.map((category) => (
                        <div className={"departures-report-create_form-category"}>
                            <div className={"departures-report-create_form-category_title"}>
                                {category.category}
                                <div className={"departures-report-create_form-category_attention"}>
                                    {category.categoryAttention}
                                </div>
                            </div>
                            <div className={"departures-report-create_form-category_items"}>
                                {category.fields.map((field) => (
                                    <Field
                                        key={field.name}
                                        label={field.label}
                                        name={field.name}
                                        options={field.options}
                                        formId={formId}
                                        propertyLabel={field.label}
                                        type={field.type}
                                        validationRules={field.validationRules}
                                        fieldStructure={field.fieldStructure}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default DeparturesReportCreate;